module.exports = __webpack_public_path__ + "static/media/6.1bee47fc.jpg";